const createBarGradient = (context: CanvasRenderingContext2D, color1: string, color2: string) => {
    const gradient = context.createLinearGradient(0, 0, context.canvas.width, 0);
    gradient.addColorStop(0, color1);
    gradient.addColorStop(1, color2);
    return gradient;
};

export default createBarGradient;
